<template>
  <el-dialog
    title="New Event"
    :visible.sync="isVisible"
    :close-on-click-modal="closable"
    :close-on-press-escape="closable"
    :show-close="closable"
    @closed="$emit('destroy')"
  >
    <el-dialog
      width="30%"
      title="Notice"
      :visible="isPrompting && isVisible"
      append-to-body
    >
      Would you like to create another event?

      <div slot="footer">
        <el-button @click.native="isVisible = false">
          No
        </el-button>

        <el-button
          type="primary"
          @click.native="createNewEvent"
        >
          Yes
        </el-button>
      </div>
    </el-dialog>

    <EventForm
      ref="form"
      :event="event"
      :note="note"
      :disabled-fields="disabledFields"
    />

    <template #footer>
      <el-button
        :disabled="!closable"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isCreatingEvent"
        @click.native="createEvent"
      >
        Create
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import EventForm from '@/components/Application/Sales/Events/Event/CreateForm'

export default {
  components: {
    EventForm
  },
  props: {
    event: {
      type: Object,
      required: true
    },
    cancellable: {
      type: Boolean,
      required: false,
      default: true
    },
    disabledFields: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      isVisible: true,
      isCreatingEvent: false,
      isPrompting: false,
      note: new this.$sdk.note()
    }
  },
  computed: {
    closable () {
      return this.cancellable && !this.isCreatingEvent
    }
  },
  methods: {
    async createEvent () {
      this.isCreatingEvent = true

      try {
        await this.event.create()

        if (this.note.content) {
          this.note.resource = this.event
          this.note.resource_uuid = this.event.id

          await this.note.create()
        }

        this.isPrompting = true

        this.$emit('created-event', this.event)
      } catch {
        this.$message.error('Failed to create new Event')
      }

      this.isCreatingEvent = false
    },
    createNewEvent () {
      this.isPrompting = false

      this.event = new this.$sdk.account_event()
      this.note = new this.$sdk.note()
    }
  }
}
</script>
